module.exports = __webpack_public_path__ + "static/media/02.1229c71b.png";